// extracted by mini-css-extract-plugin
export default {"userSearch-results":"SearchedUsersList_userSearch-results__MPY+h"};